import React from "react";

const RouteContext = React.createContext({});

export const useRouteContext = () => React.useContext(RouteContext);

export default RouteContext;